<template>
    <div class="functional-area-view view" :class="{ vertex: state.vertex }">
        <instructions titleKey="functionalAreaHelpTitle" property="functionalAreaHelpContent" />

        <worktop-drawing :editableFields="[ 'functionalArea' ]" />

        <div class="wrapper">
            <div class="section-content">
                <h2 class="h2" v-html="ui.t('functionalAreaTitle')"></h2>

                <option-list v-model="state.functionalArea"
                    :optionList="ui.functionalAreaOptions"
                    :withImages="true"
                    classes="big materials"
                    :enableZoom="true"
                    :linkText="ui.t('functionalAreaPreviewLinkText')"
                    :itemClasses="[ 'col-2-4' ]" />
            </div>
        </div>

        <div class="navigation">
            <div class="wrapper">
                <router-link :to="`/${state.productFamilyCode}/hobcutout`" v-html="ui.t('previous')" />
                <router-link :to="`/${state.productFamilyCode}/accessories`" @click.native="moveNext" :class="{ next: true, disabled: !ui.functionalAreaSelectionsComplete }">
                    <span class="input-tip" v-if="moveNextPrevented" v-html="ui.t('selectionsIncomplete')"></span>
                    <span v-html="ui.t('next')"></span>
                </router-link>
            </div>
        </div>

    </div>
</template>

<script async setup lang="ts">
import { computed, ref, watch } from 'vue';
import { useState, useUI } from '../store';

const moveNextPrevented = ref(false);
let moveNextTimer: number | null = null;

const { state } = useState();
const { ui } = useUI();

function moveNext() {
    moveNextPrevented.value = true;

    moveNextTimer = setTimeout(() => moveNextPrevented.value = false, 3000);
}

// const leftSideAvailabilityWatch = watch(ui, u => {
//     const leftOption = ui.functionalAreaOptions.options.find(o => o.value == "functional-area-left");
//     if (leftOption)
//         leftOption.disabled = !u.functionalAreaLeftAvailable;
// })

// const rightSideAvailabilityWatch = watch(ui, u => {
//     const rightOption = ui.functionalAreaOptions.options.find(o => o.value == "functional-area-right");
//     if (rightOption)
//         rightOption.disabled = !u.functionalAreaRightAvailable;
// })

// const leftFunctionalAreaAvailable = computed(() => {
//     // On which side hob cutout is? 1 = left, -1 = right
//     const hobCutoutSide = state.sinkHandedness == "0"
//         ? Math.sign(parseFloat(state.sinkDistanceX ?? "0") - parseFloat(state.hobcutoutDistanceX ?? "0"))
//         : Math.sign(parseFloat(state.hobcutoutDistanceX ?? "0") - parseFloat(state.sinkDistanceX ?? "0"));
// });
</script>
